import { Link } from "react-router-dom";

export const Logo = ({ className = "", onClick, showText = true }) => (
  <Link
    to="/"
    onClick={onClick}
    data-testid="header-logo"
    className={`group inline-flex items-center gap-2.5 ${className}`}
  >
    <img
      src="/ytca-logo.webp"
      alt="YTCA — You Too Can Art"
      className="h-11 w-11 rounded-full object-cover transition-transform duration-300 group-hover:scale-105"
    />
    {showText && (
      <span className="hidden font-display text-xl font-semibold tracking-tight text-foreground sm:inline">
        You Too Can Art
      </span>
    )}
  </Link>
);
